import React from 'react';
import { rawHTML } from '../common';

const ModalOption = ({fieldName, optionName, optionValue, price, image, isSelected, isDisabled, isBlankOption, optionClickHandler}) => {
  let classes = "form-option";
  classes = isSelected ? classes + ' selected' : classes;
  classes = isDisabled ? classes + ' disabled' : classes;
  classes = isBlankOption ? classes + (optionValue === 'Not Sure' ? ' unsure' : ' blank') : classes;
    
  return (
    <figure className={classes} onClick={isDisabled ? null : () => {optionClickHandler(fieldName, optionValue)}} data-bs-dismiss="modal">
      <div className="thumbnail" dangerouslySetInnerHTML={rawHTML(image)} />
      <figcaption>
        <h5>{optionName}</h5>
        {price ?
          <p>{price}</p> : null
        }
      </figcaption>
    </figure>
  );
};

export default ModalOption;